import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import React from 'react';
import PropTypes from 'prop-types';

export const MuiDialog = ({ open, onClose, className, dialogId, dialogTitleContent, dialogContent }) => {
  return (
    <Dialog open={open} onClose={onClose} className={`MuiDialogWrapper ${className}`} aria-labelledby={dialogId}>
      <DialogTitle id={dialogId}>{dialogTitleContent()}</DialogTitle>
      <DialogContent>{dialogContent()}</DialogContent>
    </Dialog>
  );
};

MuiDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  className: PropTypes.string,
  dialogId: PropTypes.string,
  dialogTitleContent: PropTypes.func,
  dialogContent: PropTypes.func,
};